/*!
 * Notepack.io 2.3.0
 * (c) 2014-2020 Damien Arrachequesne
 * Released under the MIT License.
 */
function Decoder(buffer) {
  this._offset = 0;
  if (buffer instanceof ArrayBuffer) {
    this._buffer = buffer;
    this._view = new DataView(this._buffer);
  } else if (ArrayBuffer.isView(buffer)) {
    this._buffer = buffer.buffer;
    this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
  } else {
    throw new TypeError('Invalid argument');
  }
}

function utf8Read(view, offset, length) {
  var string = '', chr = 0;
  for (var index = offset, end = offset + length; index < end; index++) {
    var byte = view.getUint8(index);
    if ((byte & 0x80) === 0x00) {
      string += String.fromCharCode(byte);
      continue;
    }
    if ((byte & 0xE0) === 0xC0) {
      string += String.fromCharCode(
        ((byte & 0x1F) << 6) |
        (view.getUint8(++index) & 0x3F)
      );
      continue;
    }
    if ((byte & 0xF0) === 0xE0) {
      string += String.fromCharCode(
        ((byte & 0x0F) << 12) |
        ((view.getUint8(++index) & 0x3F) << 6) |
        (Math.trunc(view.getUint8(++index) & 0x3F))
      );
      continue;
    }
    if ((byte & 0xF8) === 0xF0) {
      chr = ((byte & 0x07) << 18) |
        ((view.getUint8(++index) & 0x3F) << 12) |
        ((view.getUint8(++index) & 0x3F) << 6) |
        (Math.trunc(view.getUint8(++index) & 0x3F));
      if (chr >= 0x010000) { // surrogate pair
        chr -= 0x010000;
        string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
      } else {
        string += String.fromCharCode(chr);
      }
      continue;
    }
    throw new Error('Invalid byte ' + byte.toString(16));
  }
  return string;
}

Decoder.prototype._array = function (length) {
  var value = new Array(length);
  for (var index = 0; index < length; index++) {
    value[index] = this._parse();
  }
  return value;
};

Decoder.prototype._map = function (length) {
  var key = '', value = {};
  for (var index = 0; index < length; index++) {
    key = this._parse();
    value[key] = this._parse();
  }
  return value;
};

Decoder.prototype._str = function (length) {
  var value = utf8Read(this._view, this._offset, length);
  this._offset += length;
  return value;
};

Decoder.prototype._bin = function (length) {
  var value = this._buffer.slice(this._offset, this._offset + length);
  this._offset += length;
  return value;
};

Decoder.prototype._parse = function () {
  var prefix = this._view.getUint8(this._offset++);
  var value, length = 0, type = 0, hi = 0, lo = 0;

  if (prefix < 0xC0) {
    // positive fixint
    if (prefix < 0x80) {
      return prefix;
    }
    // fixmap
    if (prefix < 0x90) {
      return this._map(prefix & 0x0F);
    }
    // fixarray
    if (prefix < 0xA0) {
      return this._array(prefix & 0x0F);
    }
    // fixstr
    return this._str(prefix & 0x1F);
  }

  // negative fixint
  if (prefix > 0xDF) {
    return (0xFF - prefix + 1) * -1;
  }

  switch (prefix) {
    // nil
    case 0xC0:
      return;
    // false
    case 0xC2:
      return false;
    // true
    case 0xC3:
      return true;

    // bin
    case 0xC4:
      length = this._view.getUint8(this._offset);
      this._offset += 1;
      return this._bin(length);
    case 0xC5:
      length = this._view.getUint16(this._offset);
      this._offset += 2;
      return this._bin(length);
    case 0xC6:
      length = this._view.getUint32(this._offset);
      this._offset += 4;
      return this._bin(length);

    // ext
    case 0xC7:
      length = this._view.getUint8(this._offset);
      type = this._view.getInt8(this._offset + 1);
      this._offset += 2;
      return [type, this._bin(length)];
    case 0xC8:
      length = this._view.getUint16(this._offset);
      type = this._view.getInt8(this._offset + 2);
      this._offset += 3;
      return [type, this._bin(length)];
    case 0xC9:
      length = this._view.getUint32(this._offset);
      type = this._view.getInt8(this._offset + 4);
      this._offset += 5;
      return [type, this._bin(length)];

    // float
    case 0xCA:
      value = this._view.getFloat32(this._offset);
      this._offset += 4;
      return value;
    case 0xCB:
      value = this._view.getFloat64(this._offset);
      this._offset += 8;
      return value;

    // uint
    case 0xCC:
      value = this._view.getUint8(this._offset);
      this._offset += 1;
      return value;
    case 0xCD:
      value = this._view.getUint16(this._offset);
      this._offset += 2;
      return value;
    case 0xCE:
      value = this._view.getUint32(this._offset);
      this._offset += 4;
      return value;
    case 0xCF:
      hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
      lo = this._view.getUint32(this._offset + 4);
      this._offset += 8;
      return hi + lo;

    // int
    case 0xD0:
      value = this._view.getInt8(this._offset);
      this._offset += 1;
      return value;
    case 0xD1:
      value = this._view.getInt16(this._offset);
      this._offset += 2;
      return value;
    case 0xD2:
      value = this._view.getInt32(this._offset);
      this._offset += 4;
      return value;
    case 0xD3:
      hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
      lo = this._view.getUint32(this._offset + 4);
      this._offset += 8;
      return hi + lo;

    // fixext
    case 0xD4:
      type = this._view.getInt8(this._offset);
      this._offset += 1;
      if (type === 0x00) {
        this._offset += 1;
        return void 0;
      }
      return [type, this._bin(1)];
    case 0xD5:
      type = this._view.getInt8(this._offset);
      this._offset += 1;
      return [type, this._bin(2)];
    case 0xD6:
      type = this._view.getInt8(this._offset);
      this._offset += 1;
      return [type, this._bin(4)];
    case 0xD7:
      type = this._view.getInt8(this._offset);
      this._offset += 1;
      if (type === 0x00) {
        hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
        lo = this._view.getUint32(this._offset + 4);
        this._offset += 8;
        return new Date(hi + lo);
      }
      return [type, this._bin(8)];
    case 0xD8:
      type = this._view.getInt8(this._offset);
      this._offset += 1;
      return [type, this._bin(16)];

    // str
    case 0xD9:
      length = this._view.getUint8(this._offset);
      this._offset += 1;
      return this._str(length);
    case 0xDA:
      length = this._view.getUint16(this._offset);
      this._offset += 2;
      return this._str(length);
    case 0xDB:
      length = this._view.getUint32(this._offset);
      this._offset += 4;
      return this._str(length);

    // array
    case 0xDC:
      length = this._view.getUint16(this._offset);
      this._offset += 2;
      return this._array(length);
    case 0xDD:
      length = this._view.getUint32(this._offset);
      this._offset += 4;
      return this._array(length);

    // map
    case 0xDE:
      length = this._view.getUint16(this._offset);
      this._offset += 2;
      return this._map(length);
    case 0xDF:
      length = this._view.getUint32(this._offset);
      this._offset += 4;
      return this._map(length);
  }

  throw new Error('Could not parse');
};

function decode(buffer) {
  var decoder = new Decoder(buffer);
  var value = decoder._parse();
  if (decoder._offset !== buffer.byteLength) {
    throw new Error((buffer.byteLength - decoder._offset) + ' trailing bytes');
  }
  return value;
}

function utf8Write(view, offset, string) {
  var c = 0;
  for (var index = 0, l = string.length; index < l; index++) {
    c = string.charCodeAt(index);
    if (c < 0x80) {
      view.setUint8(offset++, c);
    }
    else if (c < 0x800) {
      view.setUint8(offset++, 0xC0 | (c >> 6));
      view.setUint8(offset++, 0x80 | (c & 0x3F));
    }
    else if (c < 0xD800 || c >= 0xE000) {
      view.setUint8(offset++, 0xE0 | (c >> 12));
      view.setUint8(offset++, 0x80 | (c >> 6) & 0x3F);
      view.setUint8(offset++, 0x80 | (c & 0x3F));
    }
    else {
      index++;
      c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(index) & 0x3FF));
      view.setUint8(offset++, 0xF0 | (c >> 18));
      view.setUint8(offset++, 0x80 | (c >> 12) & 0x3F);
      view.setUint8(offset++, 0x80 | (c >> 6) & 0x3F);
      view.setUint8(offset++, 0x80 | (c & 0x3F));
    }
  }
}

function utf8Length(string) {
  var c = 0, length = 0;
  for (var index = 0, l = string.length; index < l; index++) {
    c = string.charCodeAt(index);
    if (c < 0x80) {
      length += 1;
    }
    else if (c < 0x800) {
      length += 2;
    }
    else if (c < 0xD800 || c >= 0xE000) {
      length += 3;
    }
    else {
      index++;
      length += 4;
    }
  }
  return length;
}

function _encode(bytes, defers, value) {
  var type = typeof value, index = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;

  if (type === 'string') {
    length = utf8Length(value);

    // fixstr
    if (length < 0x20) {
      bytes.push(length | 0xA0);
      size = 1;
    }
    // str 8
    else if (length < 0x100) {
      bytes.push(0xD9, length);
      size = 2;
    }
    // str 16
    else if (length < 0x10000) {
      bytes.push(0xDA, length >> 8, length);
      size = 3;
    }
    // str 32
    else if (length < 0x100000000) {
      bytes.push(0xDB, length >> 24, length >> 16, length >> 8, length);
      size = 5;
    } else {
      throw new Error('String too long');
    }
    defers.push({ _str: value, _length: length, _offset: bytes.length });
    return size + length;
  }
  if (type === 'number') {
    // TODO: encode to float 32?

    // float 64
    if (Math.floor(value) !== value || !Number.isFinite(value)) {
      bytes.push(0xCB);
      defers.push({ _float: value, _length: 8, _offset: bytes.length });
      return 9;
    }

    if (value >= 0) {
      // positive fixnum
      if (value < 0x80) {
        bytes.push(value);
        return 1;
      }
      // uint 8
      if (value < 0x100) {
        bytes.push(0xCC, value);
        return 2;
      }
      // uint 16
      if (value < 0x10000) {
        bytes.push(0xCD, value >> 8, value);
        return 3;
      }
      // uint 32
      if (value < 0x100000000) {
        bytes.push(0xCE, value >> 24, value >> 16, value >> 8, value);
        return 5;
      }
      // uint 64
      hi = Math.trunc(value / Math.pow(2, 32));
      lo = value >>> 0;
      bytes.push(0xCF, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
      return 9;
    } else {
      // negative fixnum
      if (value >= -0x20) {
        bytes.push(value);
        return 1;
      }
      // int 8
      if (value >= -0x80) {
        bytes.push(0xD0, value);
        return 2;
      }
      // int 16
      if (value >= -0x8000) {
        bytes.push(0xD1, value >> 8, value);
        return 3;
      }
      // int 32
      if (value >= -0x80000000) {
        bytes.push(0xD2, value >> 24, value >> 16, value >> 8, value);
        return 5;
      }
      // int 64
      hi = Math.floor(value / Math.pow(2, 32));
      lo = value >>> 0;
      bytes.push(0xD3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
      return 9;
    }
  }
  if (type === 'object') {
    // nil
    if (value === null) {
      bytes.push(0xC0);
      return 1;
    }

    if (Array.isArray(value)) {
      length = value.length;

      // fixarray
      if (length < 0x10) {
        bytes.push(length | 0x90);
        size = 1;
      }
      // array 16
      else if (length < 0x10000) {
        bytes.push(0xDC, length >> 8, length);
        size = 3;
      }
      // array 32
      else if (length < 0x100000000) {
        bytes.push(0xDD, length >> 24, length >> 16, length >> 8, length);
        size = 5;
      } else {
        throw new Error('Array too large');
      }
      for (index = 0; index < length; index++) {
        size += _encode(bytes, defers, value[index]);
      }
      return size;
    }

    // fixext 8 / Date
    if (value instanceof Date) {
      var time = value.getTime();
      hi = Math.floor(time / Math.pow(2, 32));
      lo = time >>> 0;
      bytes.push(0xD7, 0, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
      return 10;
    }

    if (value instanceof ArrayBuffer) {
      length = value.byteLength;

      // bin 8
      if (length < 0x100) {
        bytes.push(0xC4, length);
        size = 2;
      } else
      // bin 16
      if (length < 0x10000) {
        bytes.push(0xC5, length >> 8, length);
        size = 3;
      } else
      // bin 32
      if (length < 0x100000000) {
        bytes.push(0xC6, length >> 24, length >> 16, length >> 8, length);
        size = 5;
      } else {
        throw new Error('Buffer too large');
      }
      defers.push({ _bin: value, _length: length, _offset: bytes.length });
      return size + length;
    }

    if (typeof value.toJSON === 'function') {
      return _encode(bytes, defers, value.toJSON());
    }

    var keys = [], key = '';

    var allKeys = Object.keys(value);
    for (index = 0, l = allKeys.length; index < l; index++) {
      key = allKeys[index];
      if (typeof value[key] !== 'function') {
        keys.push(key);
      }
    }
    length = keys.length;

    // fixmap
    if (length < 0x10) {
      bytes.push(length | 0x80);
      size = 1;
    }
    // map 16
    else if (length < 0x10000) {
      bytes.push(0xDE, length >> 8, length);
      size = 3;
    }
    // map 32
    else if (length < 0x100000000) {
      bytes.push(0xDF, length >> 24, length >> 16, length >> 8, length);
      size = 5;
    } else {
      throw new Error('Object too large');
    }

    for (index = 0; index < length; index++) {
      key = keys[index];
      size += _encode(bytes, defers, key);
      size += _encode(bytes, defers, value[key]);
    }
    return size;
  }
  // false/true
  if (type === 'boolean') {
    bytes.push(value ? 0xC3 : 0xC2);
    return 1;
  }
  // fixext 1 / undefined
  if (type === 'undefined') {
    bytes.push(0xD4, 0, 0);
    return 3;
  }
  throw new Error('Could not encode');
}

function encode(value) {
  var bytes = [];
  var defers = [];
  var size = _encode(bytes, defers, value);
  var buf = new ArrayBuffer(size);
  var view = new DataView(buf);

  var deferIndex = 0;
  var deferWritten = 0;
  var nextOffset = -1;
  if (defers.length > 0) {
    nextOffset = defers[0]._offset;
  }

  var defer, deferLength = 0, offset = 0;
  for (var index = 0, l = bytes.length; index < l; index++) {
    view.setUint8(deferWritten + index, bytes[index]);
    if (index + 1 !== nextOffset) { continue; }
    defer = defers[deferIndex];
    deferLength = defer._length;
    offset = deferWritten + nextOffset;
    if (defer._bin) {
      var bin = new Uint8Array(defer._bin);
      for (var index_ = 0; index_ < deferLength; index_++) {
        view.setUint8(offset + index_, bin[index_]);
      }
    } else if (defer._str) {
      utf8Write(view, offset, defer._str);
    } else if (defer._float !== undefined) {
      view.setFloat64(offset, defer._float);
    }
    deferIndex++;
    deferWritten += deferLength;
    if (defers[deferIndex]) {
      nextOffset = defers[deferIndex]._offset;
    }
  }
  return buf;
}

module.exports = { encode, decode };
